import { render, staticRenderFns } from "./HistoricoInativacaoFilter.vue?vue&type=template&id=30d23e92&scoped=true"
import script from "./HistoricoInativacaoFilter.vue?vue&type=script&lang=js"
export * from "./HistoricoInativacaoFilter.vue?vue&type=script&lang=js"
import style0 from "./HistoricoInativacaoFilter.vue?vue&type=style&index=0&id=30d23e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d23e92",
  null
  
)

export default component.exports